function e(r) {
  return r && r.trim() !== "";
}
function i() {
  var r = String.fromCharCode(97 + Math.floor(Math.random() * 26)),
    t = Math.random().toString(36).substring(2, 12);
  return "".concat(r).concat(t);
}
function a(r, t) {
  return r && e(r) ? o(r) : t;
}
function o(r) {
  return r.replace(" ", "");
}
function c(r) {
  return r.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
}
function u(r, t) {
  if (r == null || t == null) return r;
  var n = t - r.toString().length + 1;
  return Array(+(n > 0 && n)).join("0") + r;
}
export { c as camelToKebab, i as generateRandomId, a as getElementId, e as isNotNullOrWhitespace, o as replacedStringId, u as zeroPad };